import React from 'react';
import ReactDOM from 'react-dom';
import './src/index.css';
import App from './src/App';

ReactDOM.render(<App />, document.getElementById('root'));
